import { Shell } from 'lucide-react';
import CtaBand from '../components/CtaBand';
import OfferIcon from '../components/OfferIcon';

const offers = [
  { type: 'book' as const, name: 'Premier Regard', sub: 'Un premier regard sur les premières pages de votre histoire.', desc: 'Une lecture attentive des 40 premières pages et du prologue pour vous offrir un retour constructif sur les forces de votre texte et les pistes d’amélioration.', bullets: ['Analyse des premiers chapitres', 'Retours détaillés et bienveillants', 'Conseils pour la suite de votre écriture'] },
  { type: 'wave' as const, name: 'Immersion', sub: 'Plonger au cœur de votre récit.', desc: 'Une analyse approfondie de votre manuscrit pour explorer ses multiples dimensions et vous aider à le faire évoluer.', bullets: ['Étude des personnages, du rythme et de la structure', 'Analyse de la cohérence et des enjeux narratifs', 'Retour détaillé avec des pistes de réécriture'] },
  { type: 'boat' as const, name: 'Grand Large', sub: 'De la première page à la version prête à prendre le large.', desc: 'Un accompagnement complet et personnalisé pour vous guider dans le travail de réécriture et de perfectionnement de votre manuscrit.', bullets: ['Plusieurs allers-retours sur votre texte', 'Conseils ciblés et propositions concrètes', 'Un suivi sur mesure, dans le respect de votre univers'] },
  { type: 'feather' as const, name: 'Ligne Claire', sub: 'Pour des textes soignés jusque dans les moindres détails.', desc: 'Une correction rigoureuse de l’orthographe, de la grammaire, de la ponctuation et de la typographie, pour un texte fluide et irréprochable.', bullets: ['Correction linguistique et typographique', 'Respect de votre style et de votre voix', 'Un regard attentif pour sublimer votre texte'] },
];

export default function Prestations() {
  return (
    <>
      
      <section className="simple-page-head container-wide">
        <span className="eyebrow">Mes prestations</span>
        <div className="mini-wave" />

        <h1>Correction et relecture de manuscrits</h1>

        <p>
          Roman, nouvelle, poésie ou autre projet d’écriture :
          chaque texte mérite une attention particulière.
        </p>

        <p>
          Vous recherchez une lectrice-correctrice pour faire relire,
          analyser ou corriger votre manuscrit ?
          Je vous propose un accompagnement adapté à votre projet,
          de la première lecture à la correction finale,
          dans le respect de votre style et de votre voix.
        </p>
      </section>

      <section className="services-list container-wide">
        {offers.map((o) => (
          <article className="service-row" key={o.name}>
            <div className="service-icon"><OfferIcon type={o.type} /></div>
            <div className="service-copy">
              <h2>{o.name}</h2><h3>{o.sub}</h3><p>{o.desc}</p>
              <ul>{o.bullets.map(b => <li key={b}><Shell size={21} /> <span>{b}</span></li>)}</ul>
            </div>
          </article>
        ))}
      </section>
      <CtaBand title="Vous avez un projet et souhaitez en discuter ?" />
    </>
  );
}
